import styles from './popularBrands.scss';
import { Section } from 'components/Section';
import Image from 'components/Shared/Image';
import { Cell, Grid } from 'components/Grid';
import connect from 'components/Shared/connect';
import { isHuge, isDesktop } from 'components/Shared/responsive';
import { PopularBrandsBlock } from 'models/PopularBrandsBlock';
import { rm, hasElements, NO_ELEMENT } from 'utils';
import { NotifyLink } from 'components/Shared/NotifyLink';
import { Button } from 'components/Button';

const IMAGE_WIDTH = 150;
const IMAGE_HEIGHT = 75;

export const _PopularBrands = ({ isDesktop, brands, isHuge, url, ...props }: MergedProps) => {
  if (!hasElements(brands)) {
    return NO_ELEMENT;
  }

  const content = brands.map(({ title, url, brandImage, ticket }) => (
    <Cell key={title} className={styles.cell}>
      <NotifyLink ticket={ticket} url={url}>
        <Image
          key={title}
          height={IMAGE_HEIGHT}
          width={IMAGE_WIDTH}
          {...brandImage}
          paddingBottom
          wrapperClassName={styles.image}
        />
      </NotifyLink>
    </Cell>
  ));

  return (
    <Section contentClassName={styles.section}>
      {props.title && <h2>{props.title}</h2>}
      <Grid desktop="4" phone="2" className={styles.grid}>
        {content}
      </Grid>
      <Grid desktop="1" phone="1">
        <Cell className={styles.buttonCell}>
          <Button title={rm('show_all_brands')} size="small" href={url} className={styles.showMore}>
            <p>{rm('show_all_brands')}</p>
          </Button>
        </Cell>
      </Grid>
    </Section>
  );
};

interface MergedProps extends PopularBrandsBlock {
  isDesktop: boolean;
  isHuge: boolean;
}

export const PopularBrands = connect<MergedProps, PopularBrandsBlock>(state => ({
  isDesktop: isDesktop(state),
  isHuge: isHuge(state)
}))(_PopularBrands);
